import { render, staticRenderFns } from "./DriverReferSupplierDocs.vue?vue&type=template&id=bde79680&"
import script from "./DriverReferSupplierDocs.vue?vue&type=script&lang=js&"
export * from "./DriverReferSupplierDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports